export enum RailBarCollapseState {
  closed = 'closed',
  open = 'open',
}
